export default {
  models: {
    asset: 'Asset | Asset | Assets', // zero, one, many
    emo: 'EMO | EMO | EMOs',
    issue: 'Issue | Issue | Issues',
    image: 'Image | Image | Images',
    level: 'Level | Level | Levels',
    location: 'Location | Location | Locations',
    meter: 'Meter | Meter | Meters',
    note: 'Note | Note | Notes',
    site: 'Site | Site | Sites'
  },
  attributes: {
    desc: "Description",
    description: "Description",
    energy_source: "Energy Source",
    energy_source_id: "Energy Source",
    lat: "Latitude",
    long: "Longitude",
    area: "Floor Area",
    area_unit: "Area Unit",
    location_uuid: "Location",
    asset: {
      asset_sub_type: "Asset Sub Type",
      asset_sub_type_id: "Asset Sub Type",
      description: "Description",
      energy_source: "Energy Source",
      energy_source_id: "Energy Source",
      energy_use_cat: "Energy Use Category",
      energy_use_cat_id: "Energy Use Category",
      energy_use_sub_cat: "Energy Use Sub Category",
      name: "Asset Name",
      location: "Location",
      qty: "Qty",
      installed_on: "Installed on",
      retired_on: "Retired on",
      life_cycle_length: "Life Cycle Length",
      manufacturer: "Manufacturer",
      meter: "Meter",
      meter_uuid: "Meter",
      model_num: "Model No.",
      controls: "Controls",
      local_control: "Local",
      central_control: "Central",
      manual_control: "Manual",
      none_control: "None",
      power_cal_method: "Power calculation method",
      rated_input_power: "Rated input power",
      rated_input_power_unit: "Rated input power unit",
      rated_input_power_unit_code: "Rated input power unit",
      rated_input_power_unit_id: "Rated input power unit",
      rated_output_power: "Rated output power",
      rated_output_power_unit: "Rated output power unit",
      rated_output_power_unit_code: "Rated output power unit",
      rated_output_power_unit_id: "Rated output power unit",
      rated_efficiency_pcn: "Rated efficiency",
      serial_num: "Serial No.",
      tag: "Asset Tag"
    },
    emo: {
      name: "EMO Name",
      description: "Description",
      location: "Location",
      asset: "Asset",
      owner: "Related to",
      owner_type: "Related to type",
      energy_change: "Energy Change",
      energy_unit: "Energy Unit",
      energy_use_cat: "Energy Use Category",
      energy_use_sub_cat: "Energy Use Sub Category",
      energy_source: "Energy Source",
      energy_source_id: "Energy Source",
      emo_category: "EMO Category",
      saving_method: "Saving Method",
      saving_accuracy: "Saving Accuracy",
      saving_pcn: "Saving Percentage",
      replacement: "Replacement",
      operational: "Operational",
      administrative: "Administrative",
      maintenance: "Maintenance",
      modification: "Modification",      
      annual_saving_persistence: "Annual saving persistence"
    },
    issue: {
      desc: "Description",
      due: "Due date",
      implementation: "Implementation date",
      issue_category: "Category",
      issue_priority: "Priority",
      issue_severity: "Severity",
      title: "Title"
    },
    location: {
      name: "Location Name",
      parent: "Part of",
      building_name: "Building",
      area_name: "Area",
      level_name: "Level",
      location_name: "Location",
      description: "Description",
      area: "Floor Area",
      area_unit: "Floor Area Unit"
    },
    meter: {
      num: "Meter No.",
      multiplier: "Multplier",
      serial_no: "Serial No.",
      type: "Meter Type",
      unit_of_measure: "Unit of measure"
    },   
    note: {
      title: "Title",
      details: "Details",
      owner: "Related to",
      owner_type: "Related to type"
    },   
    site: {
      name: "Site Name",
      company: "Company",
      desc: "Description",
      address: "Address",
      city: "City",
      province: "State",
      post_code: "Post/Zip Code",
      country: "Country",
      primary_function: "Primary Function",
      site_function: "Site Function Remarks",
      area: "Total Floor Area",
      area_unit: "Area Unit",
      year_built: "Year Built",
      nb_floors: "No. of floors",
      nb_buildings: "No. of buildings",
      occupancy_pcn: "Occupancy",
      weekly_op_hours: "Weekly op Hours",
      lat: "Latitude",
      long: "Longitude"
    }
  },
  errors: {
    site: {
      no_company: "Site not linked to a company.",
      print_pdf: "Error in print PDF",
      sync_site: "Error in site sync",
      sync_import: "Error in site import"
    },
    save_image: "Problem saving image"
  },
  add: "Add",
  add_annotation: "Add Annotation",
  aims_login: "AIMS Login",
  all_sync_done_ok: "Sync of site data successfully completed",
  are_you_sure: "Are you sure?",
  back: "Back",
  binding_instance: "Binding to a new AIMS instance.",
  binding_instance_confirm: "Binding to a new instance will erase all data for the current instance, are you sure you want to proceed?",
  cancel: "Cancel",
  clear_annotations: "Clear Annotations",
  clear_data: "Clear App Data",
  cleared_all_assets: "Cleared all assets.",
  completed: "Completed",
  confirm_update_version: "New Version of AIMS2GO available! Update Now?",
  confirm_overwrite_geo: "Lat/Long already exists. Confirm overwritting existing values?",
  current_instance: "Current AIMS instance",
  delete: "Delete",
  delete_object: "Delete {object}",
  deleted_on_aims: "Deleted on AIMS",
  downloaded: "Downloaded",
  edit: "Edit",
  energy_meter: "Energy Meter",
  english: "English",
  export_to_excel_done: "Export to Excel completed",
  filter: "Filter",
  home: "Home",
  gallery: "Gallery",
  geo_location: "Geo Location",
  geo_location_success: "Geo Location updated",
  geo_location_error: "Error getting Geo Location",
  import_done: "Import Done",
  import_sites: "Import Sites",
  imported: "Imported",
  in_progress: "In Progress",
  list_sites: "List Sites",
  language: "Language",
  login: "Login",
  login_successful: "Login successful",
  login_failed: "Login failed",
  logout: "Logout",
  map: "Map",
  new: "New",
  new_instance: "New AIMS instance",
  new_object: "New {object}",
  no: "No",
  not_all_sync_done_ok: "Sync of site data completed. Not all items were uploaded successfully",
  open_map_app: "Open Map App",
  pending: "Pending",
  retake: "Retake",
  select_file: "Select File",
  settings: "Settings",
  spanish: "Español",
  submit: 'Submit',
  sync: "Sync",
  take_photo: "Take Photo",
  updated: "Updated",
  uploaded: "Uploaded",
  use_photo: "Use Photo",
  waste_meter: "Waste Meter",
  water_meter: "Water Meter",
  years: "Years",
  yes: "Yes"
}